export enum AlertNotificationFormValuesNames {
  ENABLED = 'enabled',
  USER_LIST = 'userList',
}

export interface AlertNotificationFormValues {
  [AlertNotificationFormValuesNames.ENABLED]: boolean;
  [AlertNotificationFormValuesNames.USER_LIST]: string[];
}

export const initialAlertNotificationFormValues: AlertNotificationFormValues = {
  [AlertNotificationFormValuesNames.ENABLED]: false,
  [AlertNotificationFormValuesNames.USER_LIST]: [],
};
